import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { PREVIEW_PAGES } from '../data/landing';
export function ProductPreview() {
  const [index, setIndex] = useState(0);
  const total = PREVIEW_PAGES.length;
  const go = (direction: number) => {
    setIndex(current => (current + direction + total) % total);
  };
  return <section className="bg-cream-2 py-14 md:py-20" aria-labelledby="preview-title" data-id="element-135" data-mp="1bsadrduws0wk">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-136" data-mp="1gqby0242m69m">
        <div className="mx-auto max-w-[560px] text-center" data-id="element-137" data-mp="1gor0q4qdg982">
          <Eyebrow data-id="element-138" data-mp="1limwr1n2rm0l">Mira el contenido</Eyebrow>
          <h2 id="preview-title" className="mt-4 text-[26px] leading-[1.15] sm:text-[34px] lg:text-[38px]" data-id="element-139" data-mp="1ljxyyx0vglpl">
            Contenido real. Página por página.
          </h2>
        </div>

        <div className="mx-auto mt-8 max-w-[380px]" data-id="element-140" data-mp="1zh3c1gz06kuc">
          <div className="relative" data-id="element-141" data-mp="1zhuudq3lam2o">
            <div className="overflow-hidden rounded-[14px] border border-line bg-cream-soft p-2" data-id="element-142" data-mp="tqsq08946uzb">
              <img key={PREVIEW_PAGES[index].src} src={PREVIEW_PAGES[index].src} alt={PREVIEW_PAGES[index].alt} width={630} height={846} className="block aspect-[630/846] w-full rounded-[8px] object-contain" loading="lazy" decoding="async" data-id="element-143" data-mp="orpjejdhkgp8" />
            </div>

            <button type="button" onClick={() => go(-1)} aria-label="Página anterior" className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border border-line bg-cream-soft p-1.5 text-ink transition-colors duration-150 ease-out hover:bg-cream-2" data-id="element-144" data-mp="18foy25b687zx">
              <ChevronLeftIcon className="h-4 w-4" data-id="element-145" data-mp="1w62o5qa73wrv" />
            </button>
            <button type="button" onClick={() => go(1)} aria-label="Página siguiente" className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 rounded-full border border-line bg-cream-soft p-1.5 text-ink transition-colors duration-150 ease-out hover:bg-cream-2" data-id="element-146" data-mp="1re18dudtjnx3">
              <ChevronRightIcon className="h-4 w-4" data-id="element-147" data-mp="21i972jo57djw" />
            </button>
          </div>

          <div className="mt-4 flex items-center justify-center gap-1.5" data-id="element-148" data-mp="25ijnyrdh3odj">
            {PREVIEW_PAGES.map((page, i) => <button key={page.src} type="button" onClick={() => setIndex(i)} aria-label={`Ver página ${i + 1}`} aria-current={i === index} className={`h-1.5 rounded-full transition-colors duration-150 ease-out ${i === index ? 'w-4 bg-gold' : 'w-1.5 bg-line'}`} data-id="element-149" data-mp="1rmoaj11uf5hj" data-mpi={i} />)}
          </div>

          <p className="mt-3 text-center text-[10px] font-medium text-ink-muted" data-id="element-150" data-mp="3gzjd5e4ixn3c">
            Contenido real del Mega Pack.
          </p>
        </div>
      </div>
    </section>;
}